"use client";
import { PiMagnifyingGlassBold } from "react-icons/pi";
import { Title, Input } from "rizzui";

type FilterElementProps = {
  onSearch: (searchTerm: string) => void;
  searchTerm: string;
};

export default function FilterPayment({
  onSearch,
  searchTerm,
}: FilterElementProps) {
  return (
    <div className="mb-4">
      <div className="relative flex z-50 mb-4 w-full flex-col md:flex-row flex-wrap items-center justify-between gap-2.5 @container ">
        <div className="flex flex-1 w-full flex-row gap-2 items-center justify-between">
          <Title as="h5" className="@xl:basis-auto text-xl md:text-2xl">
            Payment Listing
          </Title>
        </div>
        <div className="flex flex-1 w-full flex-col md:flex-row gap-2">
          <Input
            type="search"
            placeholder="Search by name, description..."
            value={searchTerm}
            onClear={() => onSearch("")}
            onChange={(event) => onSearch(event.target.value)}
            prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
            rounded="lg"
            clearable
            className="w-full @xl:ms-auto ml-auto @xl:w-auto  @4xl:w-[230px] @5xl:w-auto"
          />
        </div>
      </div>
    </div>
  );
}
